import { gql } from '@apollo/client';

import { useQuery } from "@apollo/client/react";

export const useRoleCheck = (username) => {

  const variables = {
    variables: {
      username: username
    }
  };

  const {data, loading} = useQuery(ROLECHECK, variables);
  
  if(!loading) {
    return data?.HasRole === "true";
  }
}

const ROLECHECK = gql`
query roleCheck($username: String!) {
  HasRole(username: $username)
}
`;
